module.exports = __webpack_public_path__ + "static/media/transaction_arrows.23007710.svg";